import React, { useEffect, useState } from 'react'

const StaticPackageShimmer = () => {

    return (
        <section className="ContentArea">
            <div className="container">
                <div className="progress_main">
                    <div className="row ">

                        <div className="col-md-12">
                        </div>
                        <div className="col-md-12">
                            <div className="result_col w-100">
                                <div className="border__box mb-4 ">
                                    <div className="timeline-item">
                                        <div className="animated-background">
                                            <div className="background-masker header-top" />
                                            <div className="background-masker header-left" />
                                            <div className="background-masker header-right" />
                                            <div className="background-masker header-bottom" />
                                            <div className="background-masker subheader-bottom" />
                                            <div className="background-masker place_one " />
                                            <div className="background-masker place_two " />
                                            <div className="background-masker place_three " />
                                            <div className="background-masker place_four " />
                                            <div className="background-masker place_five " />
                                            <div className="background-masker place_six " />
                                        </div>
                                        <div className="animated-background mb-0">
                                            <div className="background-masker header-top" />
                                            <div className="background-masker header-left" />
                                            <div className="background-masker header-right" />
                                            <div className="background-masker header-bottom" />
                                            <div className="background-masker subheader-bottom" />
                                            <div className="background-masker place_one " />
                                            <div className="background-masker place_two " />
                                            <div className="background-masker place_three " />
                                            <div className="background-masker place_four " />
                                            <div className="background-masker place_five " />
                                            <div className="background-masker place_six " />
                                        </div>
                                    </div>
                                </div>
                                <div className="border__box mb-4 ">
                                    <div className="timeline-item">
                                        <div className="animated-background">
                                            <div className="background-masker header-top" />
                                            <div className="background-masker header-left" />
                                            <div className="background-masker header-right" />
                                            <div className="background-masker header-bottom" />
                                            <div className="background-masker subheader-bottom" />
                                            <div className="background-masker place_one " />
                                            <div className="background-masker place_two " />
                                            <div className="background-masker place_three " />
                                            <div className="background-masker place_four " />
                                            <div className="background-masker place_five " />
                                            <div className="background-masker place_six " />
                                        </div>
                                        <div className="animated-background mb-0">
                                            <div className="background-masker header-top" />
                                            <div className="background-masker header-left" />
                                            <div className="background-masker header-right" />
                                            <div className="background-masker header-bottom" />
                                            <div className="background-masker subheader-bottom" />
                                            <div className="background-masker place_one " />
                                            <div className="background-masker place_two " />
                                            <div className="background-masker place_three " />
                                            <div className="background-masker place_four " />
                                            <div className="background-masker place_five " />
                                            <div className="background-masker place_six " />
                                        </div>
                                    </div>
                                </div>
                                <div className="border__box mb-4 ">
                                    <div className="timeline-item">
                                        <div className="animated-background">
                                            <div className="background-masker header-top" />
                                            <div className="background-masker header-left" />
                                            <div className="background-masker header-right" />
                                            <div className="background-masker header-bottom" />
                                            <div className="background-masker subheader-bottom" />
                                            <div className="background-masker place_one " />
                                            <div className="background-masker place_two " />
                                            <div className="background-masker place_three " />
                                            <div className="background-masker place_four " />
                                            <div className="background-masker place_five " />
                                            <div className="background-masker place_six " />
                                        </div>
                                        <div className="animated-background mb-0">
                                            <div className="background-masker header-top" />
                                            <div className="background-masker header-left" />
                                            <div className="background-masker header-right" />
                                            <div className="background-masker header-bottom" />
                                            <div className="background-masker subheader-bottom" />
                                            <div className="background-masker place_one " />
                                            <div className="background-masker place_two " />
                                            <div className="background-masker place_three " />
                                            <div className="background-masker place_four " />
                                            <div className="background-masker place_five " />
                                            <div className="background-masker place_six " />
                                        </div>
                                    </div>
                                </div>
                                <div className="border__box mb-4 ">
                                    <div className="timeline-item">
                                        <div className="animated-background">
                                            <div className="background-masker header-top" />
                                            <div className="background-masker header-left" />
                                            <div className="background-masker header-right" />
                                            <div className="background-masker header-bottom" />
                                            <div className="background-masker subheader-bottom" />
                                            <div className="background-masker place_one " />
                                            <div className="background-masker place_two " />
                                            <div className="background-masker place_three " />
                                            <div className="background-masker place_four " />
                                            <div className="background-masker place_five " />
                                            <div className="background-masker place_six " />
                                        </div>
                                        <div className="animated-background mb-0">
                                            <div className="background-masker header-top" />
                                            <div className="background-masker header-left" />
                                            <div className="background-masker header-right" />
                                            <div className="background-masker header-bottom" />
                                            <div className="background-masker subheader-bottom" />
                                            <div className="background-masker place_one " />
                                            <div className="background-masker place_two " />
                                            <div className="background-masker place_three " />
                                            <div className="background-masker place_four " />
                                            <div className="background-masker place_five " />
                                            <div className="background-masker place_six " />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>

    )
}

export default StaticPackageShimmer